import { useEffect, useState } from 'react';
import { resolveSecureUrl } from '../../core/files/secureUrl.js';

/**
 * @param {{
 *   src?: string | null,
 *   alt?: string,
 *   className?: string,
 *   loading?: 'eager' | 'lazy',
 *   onError?: (e: any) => void,
 * }} props
 */
export function SecureImage({ src, alt = '', className = '', loading = 'lazy', onError }) {
  const [resolvedSrc, setResolvedSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setResolvedSrc(null);

    resolveSecureUrl(src)
      .then((url) => {
        if (!cancelled) setResolvedSrc(url);
      })
      .catch(() => {
        if (!cancelled) setResolvedSrc(null);
      });

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (!resolvedSrc) {
    return null;
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      loading={loading}
      onError={onError}
    />
  );
}

